import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Reveal } from './Reveal';
import { SERVICES, IMAGES } from '../lib/site';

const LAYOUT = [
    'lg:col-span-4 lg:row-span-2',
    'lg:col-span-2',
    'lg:col-span-2',
    'lg:col-span-2',
    'lg:col-span-2',
    'lg:col-span-2',
];

export default function ServicesBentoGrid() {
    return (
        <section className="py-24 sm:py-32">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <Reveal>
                    <p className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-bronze flex items-center gap-3">
                        <span className="inline-block w-10 h-px bg-bronze" />
                        The Practice
                    </p>
                    <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-cream max-w-2xl">
                        Six disciplines. <span className="text-bronze">One integrated program.</span>
                    </h2>
                </Reveal>

                <div
                    data-testid="services-bento-grid"
                    className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4"
                >
                    {SERVICES.map((s, i) => (
                        <motion.div
                            key={s.id}
                            data-testid={s.testId}
                            initial={{ opacity: 0, y: 36 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: '-40px' }}
                            transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                            className={`group relative border border-line bg-surface/60 hover:border-bronze/60 transition-colors duration-500 overflow-hidden ${LAYOUT[i]}`}
                        >
                            {i === 0 && (
                                <>
                                    <img
                                        src={IMAGES.skyline}
                                        alt="Daylight city skyline representing CommPro Worldwide media reach and market adoption programs"
                                        className="absolute inset-0 w-full h-full object-cover opacity-25 grayscale-[40%] group-hover:opacity-35 group-hover:scale-105 transition-all duration-700"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-transparent" />
                                </>
                            )}
                            <div className="relative p-8 flex flex-col justify-end h-full min-h-[15rem]">
                                <span className="font-mono text-[10px] tracking-[0.3em] text-bronze">
                                    {String(i + 1).padStart(2, '0')}
                                </span>
                                <h3 className="mt-3 font-serif text-xl sm:text-2xl font-medium text-cream leading-snug">
                                    {s.title}
                                </h3>
                                <p className="mt-3 text-sm text-fog leading-relaxed">{s.desc}</p>
                                <Link
                                    to="/services"
                                    data-testid={`service-link-${s.id}`}
                                    className="mt-5 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-fog group-hover:text-bronze transition-colors duration-300"
                                >
                                    Details
                                    <ArrowUpRight size={12} className="group-hover:rotate-45 transition-transform duration-300" />
                                </Link>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
